@if (!isCustomer) {
<div class="p-grid margin-up">
  <div class="calendarContainer col-12 col-md-10">
    @if (calendarOptions) {
    <full-calendar #calendar [options]="calendarOptions">
    </full-calendar>
    }
  </div>
  <div class="col-0 col-md-2 ui-fluid hide-small calendarContainer">
    @if (customerIssueWOs?.length > 0) {
    <div class="col-12 center">
      <h6>Customer Issues</h6>
    </div>
    }
    @if (customerIssueWOs?.length > 0) {
    <p-scrollpanel class="customerIssue">
      @for (wo of customerIssueWOs; track wo) {
      <div class="spacing-stuff">
        <app-work-order-item class="fc-event" [workOrder]="wo" (click)="clickWOEvent(wo)"></app-work-order-item>
      </div>
      }
    </p-scrollpanel>
    }
    <div class="col-12 center">
      <h6>Anytime Quotes</h6>
    </div>
    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-search"></i></p-inputgroup-addon>
      <input pInputText placeholder="Filter" name="searchTerm" [(ngModel)]="searchTerm"
        (ngModelChange)="currencyInputChanged($event)" />
    </p-inputgroup>
    <p-scrollpanel class="anytimeQuotes" [style]="{'height': '100%', 'max-height': '75vh'}">
      <div #external>
        @if (loadingUnscheduledAnytime) {
        <div style="text-align: center; margin-top: 10px;">
          <i class="pi pi-spin pi-spinner" style="font-size: 3em;"></i>
        </div>
        }
        @if (!loadingUnscheduledAnytime && anytimeQuoteRequests?.length <= 0) { 
        <div class="zipSection">
          There are currently no unscheduled Anytime Quote Requests for you.
        </div>
        }
        @for (quoteRequest of anytimeQuoteRequests | quoteRequestFilter: searchTerm; track quoteRequest.id) {
        <div class="zipSection">
          <app-quote-request-item class='fc-event' [quoteRequest]="quoteRequest" [id]="quoteRequest.id"
            [attr.id]="quoteRequest.id" [attr.editable]="true"
            [attr.address]="quoteRequest.address.street + ', ' + quoteRequest.address.city + ' ' + (quoteRequest.address.state != null ? quoteRequest.address.state.abbreviation : '') + ', ' + quoteRequest.address.zip"
            [attr.customerId]="quoteRequest.customerId"
            [attr.customerName]="customerService.getCustomerFullName(quoteRequest.customer)"
            [attr.description]="quoteRequest.description" [attr.callAhead]="quoteRequest.callAhead"
            [attr.isUrgent]="quoteRequest.isUrgent"
            [attr.phoneNumber]="customerService.getPrimaryContact(quoteRequest.customer).phoneNumber"
            [attr.quoteRequestId]="quoteRequest.id"
            [attr.services]="customQuoteRequestService.getQuoteRequestServicesRequested(quoteRequest)"
            [attr.lastSent]="quoteRequest.onMyWaLastSent"
            [attr.timeBackgroundColor]="quoteRequest.customer.address.geoColor"
            [attr.timeTextColor]="quoteRequest.customer.address.textColor" [attr.type]="quoteRequest.quoteRequestType"
            [attr.zipCode]="quoteRequest.address.zip" (click)="clickEvent(quoteRequest.id)"></app-quote-request-item>
        </div>
        }
      </div>
    </p-scrollpanel>
  </div>
</div>
}

@if (displayNewEventModal) {
<app-new-event-modal [display]="displayNewEventModal" [blockToUpdate]="blockToUpdate" (emitClose)="closeNewEventModal()"
  (emitSubmit)="saveNewEvent($event)"></app-new-event-modal>
}
@if (showAdditionalInfoModal) {
<app-additional-info-modal [display]="showAdditionalInfoModal" [quoteRequest]="selectedRFQ" [event]="selectedEvent"
  (emitClose)="closeAdditionalInfoModal()"></app-additional-info-modal>
}

<p-confirmDialog [key]="1"></p-confirmDialog>